import { ModelBase } from 'store/model-base';
import { PromotionOffer, PromotionType } from 'core/constants';

export class OrderItemPromotion extends ModelBase {
    public type: PromotionType;
    public value: number;
    public valueTotal: number;
    public percentValue: number;
    public promoDescription: string;
    public promoContent?: string;
    public id: string;
    public offerId: string;
    public promotionTerm: number;
    public isAmount: boolean;
    public isPercentage: boolean;
    public isPrepaid: boolean;
    public isExtendedPromo: boolean;
    public isExtendedPromoDollar: boolean;
    public isExtendedPromoPercentage: boolean;
    public isExtendedPromoUpgrade: boolean;
    public isTradeInPromo: boolean;
    public isServiceLinePromo: boolean;
    public isByoPromoOffBOID: boolean;
    public isServiceAccountPromo: boolean;
    public isTradeInGiftCard: boolean;
    public isXMCPromotion: boolean;
    public isTradeInPromoPlusUp: boolean;
    public static create<T extends ModelBase>(data: ApiResponse = {}): T {
        data.isAmount = data.type === PromotionType.DOLLAR_AMOUNT;
        data.isPercentage = data.type === PromotionType.PERCENTAGE;
        data.isPrepaid = data.type === PromotionType.GIFT_CARD;
        data.isExtendedPromo = data.type === PromotionType.EXTENDED_PROMO;
        data.isExtendedPromoDollar = data.type === PromotionType.EXTENDED_PROMO_DOLLAR;
        data.isExtendedPromoPercentage = data.type === PromotionType.EXTENDED_PROMO_PCT;
        data.isExtendedPromoUpgrade = data.type === PromotionType.EXTENDED_PROMO_UPGRADE;
        data.isTradeInPromo = data.type === PromotionType.TRADEIN_PROMO || PromotionType.TRADEIN_PROMO_DDA;
        data.isTradeInGiftCard = data.type === PromotionType.TRADEIN_PROMO_GC;
        data.isServiceLinePromo = data.type === PromotionType.SERVICE_PROMO_LINE || data.type === PromotionType.SERVICE_PROMO_LINE_DISCOUNT;
        data.isServiceAccountPromo = data.type === PromotionType.SERVICE_PROMO_ACCOUNT || data.type === PromotionType.SERVICE_PROMO_ACCOUNT_DISCOUNT;
        data.isByoPromoOffBOID = data.offerId === PromotionOffer.BYOD_LL_SERP;
        data.isXMCPromotion = data.type === PromotionType.INSURANCE_PROMO_LINE_DISCOUNT;
        data.isTradeInPromoPlusUp = data.type === PromotionType.TRADEIN_PROMO_PLUSUP;
        
        return super.create<T>(data);
    }
}
